/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowRightFromLine = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M3 5v14" }],
    ["path", { d: "M21 12H7" }],
    ["path", { d: "m15 18 6-6-6-6" }]
  ]
];

export { ArrowRightFromLine as default };
//# sourceMappingURL=arrow-right-from-line.js.map
